import { useContext } from "react";
import { appContext } from "../../context/AppContext";
import { AccountPageSection } from "../../layouts/AccountPageSection";
import { Grid } from "@mui/material";
import Parcel from "single-spa-react/parcel";

export function AccountTeam(props) {
  const context = useContext(appContext);
  return (
    <AccountPageSection testId={"account-team-members"} label={"Account CLT"}>
      <Grid item xs={12}>
        <Parcel
          config={() => System.import("@mytw/account-team-members")}
          {...props}
          accountId={context.appConfig.accountId}
        />
      </Grid>
    </AccountPageSection>
  );
}
